export default __webpack_public_path__ + "static/media/default_avatar.b07fb630.svg";